import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const APIUsageChart = ({ data }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-elevation-3">
          <p className="text-sm font-medium text-foreground mb-2">{payload?.[0]?.payload?.endpoint}</p>
          <div className="space-y-1">
            <p className="text-xs text-success">
              Success: {payload?.[0]?.value?.toLocaleString()} requests
            </p>
            <p className="text-xs text-error">
              Failed: {payload?.[1]?.value?.toLocaleString()} requests
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-elevation-2 border border-border">
      <div className="mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl font-semibold text-foreground mb-1">API Usage Analytics</h2>
        <p className="text-sm text-muted-foreground">Request volume by endpoint (Last 24 hours)</p>
      </div>

      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="API Usage Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="endpoint"
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
              label={{ value: 'Requests', angle: -90, position: 'insideLeft', fill: 'var(--color-muted-foreground)' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
            <Bar dataKey="success" fill="var(--color-success)" name="Successful" radius={[4, 4, 0, 0]} />
            <Bar dataKey="failed" fill="var(--color-error)" name="Failed" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default APIUsageChart;